import actionCreatorFactory from 'typescript-fsa'
import { CardEntity } from '../cards/types'

const actionCreator = actionCreatorFactory()

export const ModalsActions = {
  addModal: actionCreator<CardEntity>('ADD_MODAL'),
  resetModal: actionCreator('RESET_MODAL')
}
